{
  "common": {
    "yes": "Да",
    "no": "Не",
    "next": "Следеће",
    "previous": "Претходно",
    "submit": "Пошаљи",
    "actions": "Акције",
    "noData": "Нема података",
    "filters": "Филтери",
    "page": "Страница",
    "otherInputPlaceholder": "Молимо наведите...",
    "otherAnswerLabel": "Други одговор",
    "otherNumberPlaceholder": "Унесите број...",
    "performingAction": "Извршавање акције...",
    "otherNumericInputLabel": "Број корисника погођених инцидентом",
    "errors": {
      "email": "Поље мора бити важећа емаил адреса",
      "minlength": "Поље мора имати најмање {{requiredLength}} карактера. Тренутна дужина је {{actualLength}}",
      "required": "Поље је обавезно",
      "maxlength": "Поље може имати највише {{requiredLength}} карактера. Тренутна дужина је {{actualLength}}",
      "pattern": "Поље мора одговарати шаблону {{requiredPattern}}",
      "min": "Поље мора бити најмање {{min}}",
      "max": "Поље може бити највише {{max}}",
      "websitePattern": "Молимо унесите важећи URL сајта (нпр. https://example.com)",
      "durationPattern": "Молимо унесите важеће трајање у формату {{durationLabel}}",
      "pageNotFound": "Нема активних форми",
      "pageNotFoundDescription": "Нема активних форми. Молимо, покушајте поново касније или контактирајте подршку.",
      "startsWith": "Поље мора почињати са {{startsWith}} и садржати само цифре",
      "minDate": "Датум мора бити после {{minDate}}",
      "maxDate": "Датум мора бити пре {{maxDate}}",
      "step": "Поље мора бити умножак од {{step}}",
      "mustMatchPassword": "Лозинке се не подударају",
      "strongPassword": "Лозинка мора бити најмање 8 карактера, садржавати најмање један велики број, један мали број и један посебан карактер"
    },
    "toast": {
      "success": "Успех",
      "warning": "Упозорење",
      "error": "Грешка",
      "languageChanged": "Језик је промењен"
    },
    "enums": {
      "incidentStatus": {
        "status": "Статус",
        "REPORTED": "Пријављен инцидент",
        "REPORT_SUBMITTED": "Достављено додатно обавештење",
        "ADDITIONAL_REPORT_SUBMITTED": "Достављен додатни извештај",
        "CLOSED": "Достављен завршни извештај",
        "DISMISSED": "Отклоњен"
      },
      "mediaType": {
        "UNKNOWN": "Непознато",
        "IMAGE": "Слика",
        "VIDEO": "Видео",
        "SVG": "СВГ",
        "AUDIO": "Аудио",
        "PDF": "ПДФ",
        "WORD": "Ворд документ",
        "ARCHIVE": "Архива"
      }
    },
    "reportType": {
      "title": "Шта пријављујете?",
      "description": "Изаберите врсту пријаве да бисте отворили одговарајући формулар.",
      "incident": "Инцидент",
      "incidentDescription": "Инцидент који се догодио у ИКТ систему.",
      "avoided": "Избегнути инцидент",
      "avoidedDescription": "Инцидент који је спречен пре него што је наступио.",
      "change": "Промени врсту пријаве",
      "downloadPdf": "Преузми ПДФ образац"
    }
  },
  "auth": {
    "forgotPassword": "Заборавили сте лозинку?",
    "login": "Пријавите се",
    "returnToLogin": "Вратите се на пријаву",
    "sendEmail": "Пошаљите е-пошту",
    "resetPassword": "Ресетујте лозинку",
    "register": "Региструјте се",
    "alreadyHaveAccount": "Већ имате налог?",
    "otpCode": "ОТП код",
    "otpExpiresIn": "Истиче за",
    "otpExpired": "Отп код је истекао, молимо покушајте поново",
    "setPassword": {
      "title": "Поставите нову лозинку",
      "description": "Изаберите сопствену лозинку да бисте наставили. Након тога ћете се поново пријавити са њом.",
      "submit": "Сачувајте лозинку",
      "signOut": "Одјавите се"
    },
    "fields": {
      "name": "Име",
      "email": "Е-пошта",
      "password": "Лозинка",
      "newPassword": "Нова лозинка",
      "repeatPassword": "Понови лозинку"
    }
  },
  "sidebar": {
    "reportIncident": "Пријави инцидент",
    "signOut": "Одјави се",
    "viewReportedIncidents": "Преглед пријављених инцидената",
    "editProfile": "Прегледај профил",
    "avoidedIncidents": "Преглед избегнутих инцидената"
  },
  "languagePicker": {
    "en": "English",
    "sr": "Srpski (latinica)",
    "cyr": "Српски (ћирилица)"
  },
  "languages": {
    "en": "Енглески",
    "sr": "Српски (латиница)",
    "cyr": "Српски (ћирилица)"
  },
  "submittedForms": {
    "single": {
      "noFields": "Нема поља за приказ"
    }
  },
  "confirmations": {
    "delete": "Обрисати ову ставку?",
    "submitForm": "Да ли сте сигурни да желите да пошаљете формулар?"
  },
  "primeng": {
    "multiselect": {
      "selectedItemsLabel": "{0} ставки изабране"
    }
  },
  "buttons": {
    "no": "Откажи",
    "yes": "Потврди"
  }
}
